import { useStoreProjectStructure } from '@/Store/storeProjectStructure';

export function addNewCaseToList(id: string, image?: string | undefined) {
    useStoreProjectStructure().addCase(
        {
            id: id,
            name: 'Мой шкаф',
            image: image ?? '',
            date: Date().toString(),
            cost: 0,
            count: 1,
        },
    );
    useStoreProjectStructure().setSelectedCaseId(id);
}
